import type { Popover } from '@systemeio/components'
import type { ComponentProps } from 'react'

type PopupInitialFocus = ComponentProps<typeof Popover.Popup>['initialFocus']

/**
 * Base UI focuses the first control inside a popup on every open, and the browser rings it because
 * a scripted focus counts as keyboard-driven. Panels resolve `initialFocus` per open instead —
 * `true` is that default move, `false` leaves focus alone — so only a keyboard open pulls focus in.
 */
export const focusPanelOnKeyboardOpenOnly: PopupInitialFocus = openType => openType === 'keyboard'
